<template>
	<div v-if="(rating && main) || areValuesFromItem" class="trustpilot-opinion">
		<div v-if="main" class="trustpilot-opinion__logo"><GlobalIcon name="trustpilot-icon" :height="16" /></div>
		<v-divider v-if="main" vertical></v-divider>
		<div v-if="!main" class="trustpilot-opinion__rating">{{ formatRating(ratings ?? rating?.ratings) }}</div>
		<div class="trustpilot-opinion__stars">
			<GlobalRating :rating="ratings ?? rating?.stars" readonly colorFilled="#00B67A" colorEmpty="#00B67A" />
		</div>
		<div v-if="!main" class="trustpilot-opinion__brand">Trustpilot</div>
		<nuxt-link v-if="(rating?.url && main) || trustpilotUrl" :to="trustpilotUrl ?? rating?.url" target="_blank" @click.stop>
			<div class="trustpilot-opinion__amount" :class="{ 'trustpilot-opinion__amount--dark': main }">
				{{ countRatings ?? rating?.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
			</div>
		</nuxt-link>
		<div v-else class="trustpilot-opinion__amount">
			{{ countRatings ?? rating?.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
		</div>
	</div>
</template>

<script lang="ts" setup>
const props = defineProps<{
	main?: boolean
	countRatings?: number
	ratings?: number | string
	trustpilotUrl?: string
}>()

const trustpilotRatingsStore = useTrustpilotRatingsStore()
const rating = computed(() => trustpilotRatingsStore.getTrustpilotRating)

const areValuesFromItem = computed(() => !!props.countRatings && !!props.ratings && !!props.trustpilotUrl)
</script>

<style lang="scss" src="./TrustpilotOpinion.scss"></style>
